module.exports = __webpack_public_path__ + "static/media/AreaofImpact.dd501ec5.svg";